/**
 * App-wide toast messages (shown by <Toaster /> in App.js).
 *
 *   toast.success('Devices uploaded', '12 added · 2 skipped');
 *   toast.error('Upload stopped', err.message);
 *   toast.warn(title, message, { duration: 8000, action: { label: 'Undo', onClick } });
 *
 * duration 0 = stays until closed.
 */
const listeners = new Set();
let nextId = 1;

const DEFAULT_MS = { success: 4500, info: 4500, warn: 7000, error: 9000 };

function show(type, title, message, options = {}) {
  const item = {
    id: nextId++,
    type,
    title: String(title || ''),
    message: message ? String(message) : '',
    duration: options.duration ?? DEFAULT_MS[type] ?? 5000,
    action: options.action || null,
  };
  listeners.forEach((fn) => fn({ kind: 'add', item }));
  return item.id;
}

export const toast = {
  success: (title, message, options) => show('success', title, message, options),
  info: (title, message, options) => show('info', title, message, options),
  warn: (title, message, options) => show('warn', title, message, options),
  error: (title, message, options) => show('error', title, message, options),
  dismiss: (id) => listeners.forEach((fn) => fn({ kind: 'remove', id })),
};

export function subscribeToasts(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export default toast;
